import { chatActivityBaseModel } from './crud';

export * from './types';

export const useChatActivitiesById = chatActivityBaseModel.fetchById();
export const useChatActivitiesByIds = chatActivityBaseModel.fetchByIds();
export const useChatActivitiesMany = chatActivityBaseModel.fetchMany();
export const useChatActivitiesCount = chatActivityBaseModel.count();
export const useChatActivitiesManyInfiniteQuery =
  chatActivityBaseModel.fetchPaginated();
export const useChatActivitiesUpdateOne = chatActivityBaseModel.edit();
export const useChatActivitiesCreateOne = chatActivityBaseModel.create();
export const useChatActivitiesRemoveOne = chatActivityBaseModel.delete();
export const useChatActivitiesRemoveByIds = chatActivityBaseModel.deleteByIds();

export const useChatActivitiesByIdV2 = chatActivityBaseModel.fetchByIdV2();
export const useChatActivitiesByIdsV2 = chatActivityBaseModel.fetchByIdsV2();
export const useChatActivitiesManyV2 = chatActivityBaseModel.fetchManyV2();
export const useChatActivitiesCountV2 = chatActivityBaseModel.countV2();
export const useChatActivitiesManyInfiniteQueryV2 =
  chatActivityBaseModel.fetchPaginatedV2();
export const useChatActivitiesUpdateOneV2 = chatActivityBaseModel.editV2();
export const useChatActivitiesCreateOneV2 = chatActivityBaseModel.createV2();
export const useChatActivitiesRemoveOneV2 = chatActivityBaseModel.deleteV2();
export const useChatActivitiesRemoveByIdsV2 =
  chatActivityBaseModel.deleteByIdsV2();

// New names based on Mongoose queries
export const useChatActivityById = chatActivityBaseModel.fetchById();
export const useChatActivityByIds = chatActivityBaseModel.fetchByIds();
export const useChatActivityMany = chatActivityBaseModel.fetchMany();
export const useChatActivityCount = chatActivityBaseModel.count();
export const useChatActivityPagination = chatActivityBaseModel.fetchPaginated();
export const useChatActivityUpdateOne = chatActivityBaseModel.edit();
export const useChatActivityCreateOne = chatActivityBaseModel.create();
export const useChatActivityRemoveOne = chatActivityBaseModel.delete();
export const useChatActivityRemoveByIds = chatActivityBaseModel.deleteByIds();

export const useChatActivityByIdV2 = chatActivityBaseModel.fetchByIdV2();
export const useChatActivityByIdsV2 = chatActivityBaseModel.fetchByIdsV2();
export const useChatActivityManyV2 = chatActivityBaseModel.fetchManyV2();
export const useChatActivityCountV2 = chatActivityBaseModel.countV2();
export const useChatActivityPaginationV2 =
  chatActivityBaseModel.fetchPaginatedV2();
export const useChatActivityUpdateOneV2 = chatActivityBaseModel.editV2();
export const useChatActivityCreateOneV2 = chatActivityBaseModel.createV2();
export const useChatActivityRemoveOneV2 = chatActivityBaseModel.deleteV2();
export const useChatActivityRemoveByIdsV2 =
  chatActivityBaseModel.deleteByIdsV2();
